/*
 * Use enum, which is compiled into an object at runtime, so we can iterate
 * over its keys.
 */
export enum EFlags {
  // Show the Pixl Group Builder in the Predicates UI
  aiGroupBuilder = 'aiGroupBuilder',
  bypassMX = 'bypassMX',
  creditCardConvenienceFeeAccepted = 'creditCardConvenienceFeeAccepted',
  // CSM's are now called Account Managers
  csmManager = 'csmManager',
  enforceOnboarding = 'enforceOnboarding',
  hasBlackbaudRaisersEdge = 'hasBlackbaudRaisersEdge',
  hasGoogleAds = 'hasGoogleAds',
  hasImis = 'hasImis',
  hasMultiConversions = 'hasMultiConversions',
  hasBuildReachAwarenessPP = 'hasBuildReachAwarenessPP',
  locales = 'locales',
  metaIntegrationOutage = 'metaIntegrationOutage',
  minBudget = 'minBudget',
  monetization = 'monetization',
  noMaxBudget = 'noMaxBudget',
  overridePackageImplementationsAccess = 'overridePackageImplementationsAccess',
  pinpoint = 'pinpoint',
  pinpointSendAllEmails = 'pinpointSendAllEmails',
  // Prevent limiting audience categories to industry, demographic or in-market
  showAllAffinityAudiences = 'showAllAffinityAudiences',
  showCampaignRecommendations = 'showCampaignRecommendations',
  showConversionsSettingsV2 = 'showConversionsSettingsV2',
  showDripBulkEnroll = 'showDripBulkEnroll',
  showDripCampaigns = 'showDripCampaigns',
  showCommandPalette = 'showCommandPalette',
  showForms = 'showForms',
  showFundraise = 'showFundraise',
  showFundraiseCRM = 'showFundraiseCRM',
  showLookalikeAudienceTargeting = 'showLookalikeAudienceTargeting',
  showOnboarding = 'showOnboarding',
  showProResources = 'showProResources',
  showUsageMetrics = 'showUsageMetrics',
  showUsersAndRolesV2 = 'showUsersAndRolesV2',
  useContactLimits = 'useContactLimits',
  useEmailLimits = 'useEmailLimits',
  zapier = 'zapier',
}

export type TFlags = keyof typeof EFlags;

export type TFlagsRecord = Partial<Record<TFlags, boolean>>;
